import { Component, ElementRef, OnInit, ViewChild, AfterViewInit } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { AuditTrailService } from "../audit-trail.service";
@Component({
  selector: "app-user-chats",
  templateUrl: "./user-chats.component.html",
  styleUrls: ["./user-chats.component.scss"],
})
export class UserChatsComponent implements OnInit {
  constructor(private auditTrailService: AuditTrailService, private _snackBar: MatSnackBar) {}
  platform: any = localStorage.getItem("platform");
  name: string = "";
  activeLang: string = "en";
  catId: any = "";
  subCatId: any = "";

  chats: any[] = [];
  isMessageInputVisible: boolean = true;
  message: string = "";
  panNo: string = "";
  ngOnInit(): void {
    // this.getPreviousChats();
  }
  async getPreviousChats() {
    let panNumber: any = "0";
    let regId: any = "0";
    if (this.panNo.match(/^\d+$/)) {
      console.log("numeric");
      panNumber = "";
      regId = this.panNo;
    } else {
      console.log("alpha");
      panNumber = this.panNo.toUpperCase();
      regId = "";
    }
    this.chats = [];
    await (
      await this.auditTrailService.getUsrChatV1(panNumber, regId)
    ).subscribe((response: any) => {
      console.log(response);
      if (response.status != "Fail") {
        this.chats = response;
      } else {
        this.chats = [];
        this._snackBar.open("No chats available.", "Close", {
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: "warning-toast",
          duration: 3 * 1000,
        });
        // this.chats = [
        //   {
        //     questions: [
        //       {
        //         queId: 99,
        //         queEng: {
        //           en: "Hi, I am here to help, may I know your name?",
        //           mr: "नमस्कार, मी मदत करण्यासाठी येथे आहे, मला तुमचे नाव कळेल का?",
        //         },
        //         dateTime: new Date(),
        //       },
        //     ],
        //     answers: [],
        //   },
        // ];
      }
    });
  }

  selectQuestion(chat: any, queEng: any) {
    if (queEng.queId != 99) {
      for (let i = 0; i < this.chats.length; i++) {
        this.chats[i]["questions"] = this.chats[i]["questions"].map((x: any) => ({ ...x, disabled: true }));
        if (this.chats[i]["answers"].length == 0) {
          this.chats[i]["answers"].push({
            ans: {
              en: queEng.queEng.en,
              mr: queEng.queEng.mr,
            },
            dateTime: new Date(),
          });
        }
      }
      this.chats.push({
        questions: [
          {
            queEng: { en: queEng.ansEng.en, mr: queEng.ansEng.mr },
            disabled: true,
            dateTime: new Date(),
            queId: "99",
          },
        ],
        answers: [],
      });
      // this.addNewData();
    }
  }

  // async getFaqQuestions() {
  //   const response: any = await this.auditTrailService.getFaqQuestions(this.message);
  //   let data: any[] = [];
  //   // for (let i = 0; i < response.length; i++) {
  //   //   data.push({
  //   //     queEng: response[i]["qusDescriptionEng"],
  //   //     queMar: response[i]["qusDescriptionMar"],
  //   //     id: response[i]["pkQusid"],

  //   //     ansEng: response[i]["qusAnswerEng"],
  //   //     ansMar: response[i]["qusAnswerMar"],

  //   //     type: "faq",
  //   //   });
  //   // }
  //   // this.chats.push({
  //   //   questions: data,
  //   //   answers: [],
  //   // });
  //   // console.log(this.chats);
  //   if (response.length > 0) {
  //     for (let i = 0; i < response.length; i++) {
  //       data.push({
  //         queEng: {
  //           en: response[i]["qusDescriptionEng"],
  //           mr: response[i]["qusDescriptionMar"],
  //         },
  //         // queMar: response[i]["qusDescriptionMar"],
  //         queId: response[i]["pkQsid"],
  //         // ansEng: response[i]["qsQuestion"]["mr"],
  //         ansEng: { en: response[i]["qusAnswerEng"], mr: response[i]["qusAnswerMar"] },
  //         // ansEng: response[i]["qusAnswerEng"],
  //         // ansMar: response[i]["qusAnswerMar"],
  //         type: "category",
  //         dateTime: new Date(),
  //       });
  //     }
  //     this.chats.push({
  //       questions: data,
  //       answers: [],
  //     });
  //   } else {
  //     data.push({
  //       queEng: {
  //         en: "I'm sorry " + this.name + " I'm unable to understand your request, can you please elaborate your query?",
  //         mr:
  //           "मला माफ करा " +
  //           this.name +
  //           " मला तुमची विनंती समजू शकली नाही, तुम्ही कृपया तुमची क्वेरी विस्तृत करू शकाल का?",
  //       },
  //       queMar:
  //         "I'm sorry " + this.name + ", I'm unable to understand your request, can you please elaborate your query?",
  //       queId: "99",
  //       type: "category",
  //       dateTime: new Date(),
  //     });
  //     this.chats.push({
  //       questions: data,
  //       answers: [],
  //     });
  //   }
  // }

  sendMessage() {
    if (this.message != "") {
      if (this.chats.length == 1) {
        var lastAddress = this.chats[this.chats.length - 1];
        lastAddress.answers.push({ ans: { en: this.message, mr: this.message }, dateTime: new Date() });

        if (
          this.message.toLowerCase() == "hi" ||
          this.message.toLowerCase() == "hello" ||
          this.message.toLowerCase() == "namaskar" ||
          this.message.toLowerCase() == "namaste"
        ) {
          this.chats.push({
            questions: [
              {
                queId: "99",
                queEng: {
                  en: this.message + ", I am here to help, may I know your name?",
                  mr: this.message + ", मी मदत करण्यासाठी येथे आहे, मला तुमचे नाव कळेल का?",
                },
                disabled: true,
                dateTime: new Date(),
              },
            ],
          });
          // this.chats.push({
          //   questions: [
          //     {
          //       queId: "99",
          //       queEng: "Hi, " + this.name + " what can I help you with today?",
          //       disabled: true,
          //       dateTime: new Date(),
          //     },
          //   ],
          //   // answers: [{ dateTime: new Date() }],
          // });
        } else {
          if (this.name == "") {
            this.name = this.message;
          }
          this.chats.push({
            questions: [
              {
                queId: "99",
                queEng: {
                  en: "Hi, " + this.name + " what can I help you with today?",
                  mr: this.name + " आज मी तुला काय मदत करू शकतो?",
                },
                disabled: true,
                dateTime: new Date(),
              },
            ],
            // answers: [{ dateTime: new Date() }],
          });
        }
      } else if (this.chats.length >= 2) {
        var lastAddress = this.chats[this.chats.length - 1];
        lastAddress.answers = [{ ans: { en: this.message, mr: this.message }, dateTime: new Date() }];
        if (
          // this.message.toLowerCase().includes("end") ||
          // this.message.toLowerCase().includes("exit") ||
          // this.message.toLowerCase().includes("terminate") ||
          // this.message.toLowerCase().includes("conclude") ||
          // this.message.toLowerCase().includes("close")
          this.message.toLowerCase().includes("thanks") ||
          this.message.toLowerCase().includes("thank you") ||
          this.message.toLowerCase().includes("ok")
        ) {
          // this.endChat("N");
          this.chats.push({
            questions: [
              {
                queId: "99",
                queEng: { en: "Glad that I could help you.", mr: "मी तुम्हाला मदत करू शकलो याचा आनंद झाला." },
                disabled: true,
                dateTime: new Date(),
              },
            ],
          });
        } else if (
          this.message.toLowerCase() == "hi" ||
          this.message.toLowerCase() == "hello" ||
          this.message.toLowerCase() == "namaskar" ||
          this.message.toLowerCase() == "namaste"
        ) {
          this.chats.push({
            questions: [
              {
                queId: "99",
                queEng: {
                  en: this.message + ", Please share your query, if there is any?",
                  mr: this.message + ", कृपया तुमची क्वेरी शेअर करा, काही असल्यास?",
                },
                disabled: true,
                dateTime: new Date(),
              },
            ],
          });
        } else {
          // this.getFaqQuestions();
        }
      }
      this.message = "";
    }
  }

  // maxHeight = 500;
  @ViewChild("scrollToBottom") elementView: ElementRef;
  ngAfterViewInit() {
    setTimeout(() => {
      if (this.platform == "browser" || this.platform == "browser-local") {
        // this.maxHeight = this.elementView.nativeElement.offsetHeight;
      }
    }, 1000);
    // var objDiv: any = document.getElementById("scrollToBottom");
    // // console.log(objDiv.height);
    // this.maxHeight = objDiv.scrollHeight;
  }
}
